import React from "react";
import "./styles.scss";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  let start = Math.max(currentPage - 2, 1);
  let end = Math.min(currentPage + 2, totalPages);

  if (currentPage <= 2) end = Math.min(5, totalPages);

  if (currentPage >= totalPages - 1) start = Math.max(totalPages - 4, 1);

  const pageNumbers = [];
  for (let i = start; i <= end; i++) pageNumbers.push(i);

  return (
    <div className="pagination">
      <button
        className="page-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Go to previous page"
      >
        &#8592; Prev
      </button>

      {start > 1 && (
        <>
          <button
            className="page-btn"
            onClick={() => onPageChange(1)}
            aria-label="Go to first page"
          >
            1
          </button>
          {start > 2 && <span style={{ color: "#888" }}>...</span>}
        </>
      )}

      {pageNumbers.map((page) => (
        <button
          key={page}
          className={`page-btn ${page === currentPage ? "active" : ""}`}
          onClick={() => onPageChange(page)}
          aria-current={page === currentPage ? "page" : undefined}
        >
          {page}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span style={{ color: "#888" }}>...</span>}
          <button
            className="page-btn"
            onClick={() => onPageChange(totalPages)}
            aria-label="Go to last page"
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        className="page-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Go to next page"
      >
        Next &#8594;
      </button>
    </div>
  );
};

export default Pagination;
